module.exports = __webpack_public_path__ + "img/logo.6d2d48d5.png";